import {
  Components, Theme, buttonBaseClasses, listItemTextClasses, svgIconClasses,
} from '@mui/material';
import {
  Spacing2, Spacing3, Spacing5, Spacing9, baseSpace,
} from '../spacing';
import { listItemButtonClasses, listItemClasses, listItemIconClasses } from './types';
import { Disabled, Primary, Secondary } from '../color';

export const MuiListItem: Components<Theme>['MuiListItem'] = {
  styleOverrides: {
    root: {
      [`& > :first-child:not(.${buttonBaseClasses.root})`]: {
        paddingLeft: Spacing5,
        marginBottom: Spacing2,
      },
      [`.${buttonBaseClasses.root} > :first-child`]: {
        marginTop: Spacing2,
        marginBottom: Spacing2,
      },
      [`&.${listItemClasses.withSecondaryAction} > .${listItemTextClasses.root}`]: {
        paddingRight: Spacing9,
      },
      [`.${buttonBaseClasses.root}`]: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
  defaultProps: {
    alignItems: 'flex-start',
    disablePadding: true,
    disableGutters: true,
  },
};

export const MuiListItemSecondaryAction: Components<Theme>['MuiListItemSecondaryAction'] = {
  styleOverrides: {
    root: {
      display: 'flex',
    },
  },
};

export const MuiListItemAvatar: Components<Theme>['MuiListItemAvatar'] = {
  styleOverrides: {
    root: {
      minWidth: 0,
      paddingRight: Spacing3,
    },
  },
};

export const MuiListItemText: Components<Theme>['MuiListItemText'] = {
  styleOverrides: {
    root: {
      alignSelf: 'center',
    },
  },
};

export const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: Secondary.surface.hover,
      },
      [`&.${buttonBaseClasses.disabled}`]: {
        backgroundColor: Disabled.default.main,
      },
      [`&.${listItemButtonClasses.strong}`]: {
        borderLeft: `2px solid ${Primary.container.text}`,
        paddingLeft: (baseSpace * 4) - 2,
      },

    },
  },
};

export const MuiListItemIcon: Components<Theme>['MuiListItemIcon'] = {
  styleOverrides: {
    root: {
      color: 'inherit',
      minWidth: 0,
      paddingRight: Spacing3,
      alignSelf: 'flex-start',
      [`&.${listItemIconClasses.xs} .${svgIconClasses.root}`]: {
        width: 16,
        height: 16,
      },
      [`&.${listItemIconClasses.sm} .${svgIconClasses.root}`]: {
        width: 24,
        height: 24,
      },
      [`&.${listItemIconClasses.md} .${svgIconClasses.root}`]: {
        width: 32,
        height: 32,
      },
      [`&.${listItemIconClasses.lg} .${svgIconClasses.root}`]: {
        width: 40,
        height: 40,
      },
      [`&.${listItemIconClasses.xl} .${svgIconClasses.root}`]: {
        width: 56,
        height: 56,
      },
    },
  },
};
